module.exports = __webpack_public_path__ + "static/media/warbler2.186021ed.png";